(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stellar-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellar-delivery-estimate')) {
  customElements.define('stellar-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      const update = () => {
        const parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
        const date = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
        const businessDays = Math.min(10, Math.max(1, Number(this.dataset.businessDays) || 3));
        let days = 0;
        while (days < businessDays) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days++;
        }
        const time = this.querySelector('time');
        if (!time) return;
        time.dateTime = date.toISOString().slice(0, 10);
        time.textContent = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(date);
      };
      update();
      this.refresh = setInterval(update, 60000);
    }
    disconnectedCallback() { clearInterval(this.refresh); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellar-feature-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellar-feature-motion')) {
  customElements.define('stellar-feature-motion', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.preloader?.disconnect();
      this.clearWatch();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.frame = this.querySelector('.stellar-motion__frame');
      if (!this.video || !this.frame) return;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopPreference = this.dataset.desktopVideo ? matchMedia('(min-width: 990px)') : null;
      this.desktopPreference?.addEventListener('change', () => {
        this.stop();
        this.limit = 0;
        this.blocked = '';
        this.classList.add('is-motion-pending');
        this.reconcile();
      }, options);
      this.userPaused = this.userPaused === true;
      this.toggle = this.querySelector('.stellar-motion__toggle');
      if (this.toggle) {
        this.toggle.textContent = this.userPaused ? 'Resume motion' : 'Pause motion';
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
      }
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggle.textContent = this.userPaused ? 'Resume motion' : 'Pause motion';
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.reconcile();
      }, options);
      this.visible = false;
      this.wanted = false;
      this.blocked = '';
      this.pending = false;
      this.serial = (this.serial || 0) + 1;
      this.abortRetries = 0;
      this.limit = 0;
      this.rate = Number(this.dataset.playbackRate) || 1;
      this.start = Number(this.dataset.clipStart) || 0;
      this.end = Number(this.dataset.clipEnd) || 0;
      this.jumpAt = Number(this.dataset.jumpAt) || 0;
      this.jumpTo = Number(this.dataset.jumpTo) || 0;
      this.expectedDuration = Number(this.dataset.expectedDuration) || 0;
      this.jumpEnabled = false;
      this.video.muted = this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.video.loop = !this.start && !this.end;
      this.video.playbackRate = this.video.defaultPlaybackRate = this.rate;
      this.video.addEventListener('loadedmetadata', () => this.prepare(), options);
      this.video.addEventListener('canplay', () => this.reconcile(), options);
      this.video.addEventListener('seeked', () => this.reconcile(), options);
      this.video.addEventListener('playing', () => {
        if (!this.allowed()) { this.stop(); return; }
        this.classList.remove('is-motion-pending');
        this.dataset.motionState = 'playing';
        this.abortRetries = 0;
        this.watch();
      }, options);
      this.video.addEventListener('timeupdate', () => this.check(), options);
      this.video.addEventListener('ended', () => this.rewind(), options);
      this.video.addEventListener('pause', () => this.clearWatch(), options);
      this.video.addEventListener('error', () => {
        this.blocked = 'error';
        this.classList.add('is-motion-pending');
        this.dataset.motionState = 'error';
        this.stop();
      }, options);
      const retryPolicy = () => {
        if (this.blocked === 'policy') this.blocked = '';
        this.abortRetries = 0;
        this.reconcile();
      };
      document.addEventListener('pointerdown', retryPolicy, options);
      document.addEventListener('keydown', retryPolicy, options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) retryPolicy();
        else this.reconcile();
      }, options);
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) this.classList.add('is-motion-pending');
        this.reconcile();
      }, options);
      if ('IntersectionObserver' in window) {
        this.preloader = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && !this.preference.matches) this.load();
        }, { rootMargin: '480px 0px' });
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.observeVisibility(entry.isIntersecting && entry.intersectionRatio >= .15);
        }, { threshold: [0, .15] });
        this.preloader.observe(this.frame);
        this.observer.observe(this.frame);
      } else {
        const measure = () => {
          const r = this.frame.getBoundingClientRect();
          const overlap = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
          const height = r.height || r.bottom - r.top;
          this.observeVisibility(r.width > 0 && height > 0 && overlap / height >= .15);
        };
        window.addEventListener('scroll', measure, { ...options, passive: true });
        window.addEventListener('resize', measure, options);
        measure();
      }
      if (this.video.readyState >= 1) this.prepare();
      this.reconcile();
    }
    allowed() {
      return this.isConnected && this.visible && !this.userPaused && !document.hidden && !this.preference.matches && !this.blocked;
    }
    observeVisibility(visible) {
      if (visible && !this.visible) {
        if (this.blocked === 'policy') this.blocked = '';
        this.abortRetries = 0;
      }
      this.visible = visible;
      this.reconcile();
    }
    load() {
      const source = this.video.querySelector('source[data-src]');
      const selectedSource = this.desktopPreference?.matches ? this.dataset.desktopVideo : source?.dataset.src;
      if (source && source.getAttribute('src') !== selectedSource) {
        this.video.preload = 'auto';
        source.src = selectedSource;
        this.video.load();
      }
    }
    prepare() {
      const duration = this.video.duration;
      if (!Number.isFinite(duration) || this.start < 0 || this.start >= duration || (this.end && this.end <= this.start)) {
        this.blocked = 'error';
        this.stop();
        return;
      }
      this.limit = this.end ? Math.min(this.end, duration) : duration;
      this.jumpEnabled = this.jumpAt > 0 && this.jumpTo > this.jumpAt && this.jumpTo < this.limit && Math.abs(duration - this.expectedDuration) < .04;
      if (this.jumpAt && !this.jumpEnabled) {
        this.blocked = 'error';
        this.classList.add('is-motion-pending');
        this.dataset.motionState = 'error';
        this.stop();
        return;
      }
      this.video.playbackRate = this.video.defaultPlaybackRate = this.rate;
      this.reconcile();
    }
    reconcile() {
      this.wanted = this.allowed();
      if (!this.wanted) {
        this.stop();
        if (this.preference.matches) {
          this.classList.add('is-motion-pending');
          this.dataset.motionState = 'reduced';
        }
        return;
      }
      this.load();
      if (!this.limit || this.video.seeking || this.video.readyState < 2 || this.pending) return;
      if (this.jumpMidpoint(this.video.currentTime)) return;
      if (this.video.currentTime < this.start || this.video.currentTime >= this.limit - .025 || this.video.ended) {
        this.video.currentTime = this.start;
        if (this.video.seeking) return;
      }
      if (!this.video.paused) return;
      const request = ++this.serial;
      this.pending = true;
      this.dataset.motionState = 'starting';
      const reject = error => {
        if (request !== this.serial) return;
        this.pending = false;
        if (error?.name === 'AbortError') {
          this.dataset.motionState = 'waiting';
          if (this.abortRetries++ < 1) {
            this.retryFrame = requestAnimationFrame(() => {
              this.retryFrame = null;
              if (request === this.serial) this.reconcile();
            });
          }
          return;
        }
        this.blocked = 'policy';
        this.wanted = false;
        this.classList.add('is-motion-pending');
        this.dataset.motionState = 'blocked';
      };
      try {
        Promise.resolve(this.video.play()).then(() => {
          if (request !== this.serial) return;
          this.pending = false;
          if (!this.allowed()) this.stop();
        }, reject);
      } catch (error) { reject(error); }
    }
    rewind() {
      if (!this.allowed()) { this.stop(); return; }
      this.stop();
      this.video.currentTime = this.start;
      this.reconcile();
    }
    jumpMidpoint(mediaTime) {
      if (!this.jumpEnabled || this.video.seeking || mediaTime < this.jumpAt - .0005 || this.video.currentTime >= this.jumpTo - .0005) return false;
      this.video.pause();
      this.video.currentTime = this.jumpTo;
      return true;
    }
    check(mediaTime = this.video.currentTime) {
      if (!this.wanted || this.video.seeking) return;
      if (this.jumpMidpoint(mediaTime)) return;
      if (!this.video.loop && this.video.currentTime >= this.limit - .025) this.rewind();
    }
    watch() {
      this.clearWatch();
      if (this.video.loop && !this.jumpEnabled) return;
      if (this.jumpEnabled && typeof this.video.requestVideoFrameCallback === 'function') {
        const frame = (now, metadata) => {
          this.videoFrame = null;
          if (!this.wanted || this.video.paused) return;
          this.check(metadata.mediaTime);
          if (this.wanted && !this.video.paused) this.videoFrame = this.video.requestVideoFrameCallback(frame);
        };
        this.videoFrame = this.video.requestVideoFrameCallback(frame);
        return;
      }
      const tick = () => {
        if (!this.wanted || this.video.paused) return;
        this.check();
        if (this.wanted && !this.video.paused) this.animationFrame = requestAnimationFrame(tick);
      };
      this.animationFrame = requestAnimationFrame(tick);
    }
    clearWatch() {
      if (this.videoFrame != null && this.video?.cancelVideoFrameCallback) this.video.cancelVideoFrameCallback(this.videoFrame);
      this.videoFrame = null;
      if (this.animationFrame != null) cancelAnimationFrame(this.animationFrame);
      if (this.retryFrame != null) cancelAnimationFrame(this.retryFrame);
      this.animationFrame = this.retryFrame = null;
    }
    stop() {
      this.wanted = false;
      this.pending = false;
      ++this.serial;
      this.clearWatch();
      this.video?.pause();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.preloader?.disconnect();
      this.stop();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellar-product-shipping-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellar-product-shipping-label')) {
  customElements.define('stellar-product-shipping-label', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.sequence = (this.sequence || 0) + 1;
      this.lastCart = null;
      try { this.variants = JSON.parse(this.querySelector('[data-shipping-variants]').textContent); }
      catch { this.variants = []; }
      document.addEventListener('change', event => {
        if (event.target.name === 'id' && event.target.form?.id === this.dataset.formId) this.update();
      }, {signal:this.controller.signal});
      this.update();
      if (this.dataset.marketEligible !== 'true') return;
      const refresh = event => {
        if (event?.cartData?.item_count != null && event.cartData.total_price != null) {
          this.sequence++;
          this.updateCart(event.cartData);
        } else this.refreshCart();
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
      window.addEventListener('focus', () => this.refreshCart(), {signal:this.controller.signal});
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refreshCart();
      }, {signal:this.controller.signal});
      this.refreshCart();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.sequence++;
    }
    async refreshCart() {
      const sequence = ++this.sequence;
      try {
        const response = await fetch(this.dataset.cartUrl, {credentials:'same-origin', cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (sequence === this.sequence && this.isConnected) this.updateCart(cart);
      } catch (error) {
        if (sequence === this.sequence && error.name !== 'AbortError') {
          this.dataset.cartTotal = '';
          this.update();
        }
      }
    }
    updateCart(cart) {
      this.lastCart = cart;
      this.dataset.cartTotal = String(cart.total_price ?? '');
      this.cartCurrencyEligible = !cart.currency || cart.currency === this.dataset.currency;
      this.dataset.discountEligible = String((Number(cart.total_discount) || 0) <= (Number(cart.original_total_price) || 0) * 0.2);
      this.update();
    }
    update() {
      const selectedId = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value || this.dataset.selectedId;
      const variant = this.variants.find(item => String(item.id) === String(selectedId));
      const threshold = Number(this.dataset.threshold);
      const eligible = this.dataset.marketEligible === 'true' && this.dataset.discountEligible === 'true' && this.cartCurrencyEligible !== false && threshold > 0;
      const cartQualified = eligible && this.dataset.cartTotal !== '' && Number(this.dataset.cartTotal) >= threshold;
      const free = eligible && (cartQualified || variant?.price >= threshold);
      this.dataset.cartQualified = String(cartQualified);
      this.dataset.free = String(free);
      const prefix = this.querySelector('[data-free-prefix]');
      if (prefix) {
        prefix.hidden = !free;
        prefix.textContent = cartQualified ? 'YOU QUALIFY FOR FREE ' : 'FREE ';
      }
      this.dispatchEvent(new CustomEvent('stellar:shipping-label-change', {bubbles:true, detail:{cart:this.lastCart}}));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellar-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellar-shipping-progress')) {
  customElements.define('stellar-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.sequence = (this.sequence || 0) + 1;
      this.lastCart = null;
      const label = this.closest('.stellar-buyer-benefits')?.querySelector('stellar-product-shipping-label');
      if (label) {
        document.addEventListener('stellar:shipping-label-change', event => {
          if (event.target === label && event.detail?.cart) this.renderCart(event.detail.cart);
        }, {signal:this.controller.signal});
        if (label.lastCart) this.renderCart(label.lastCart);
        return;
      }
      document.addEventListener('stellar:shipping-label-change', event => {
        if (event.target.closest('.stellar-buyer-benefits') === this.closest('.stellar-buyer-benefits') && this.lastCart) this.renderCart(this.lastCart);
      }, {signal: this.controller.signal});
      const refresh = event => {
        if (event?.cartData?.item_count != null && event.cartData.total_price != null) {
          this.sequence++;
          this.renderCart(event.cartData);
        } else this.refreshCart();
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
      window.addEventListener('focus', () => this.refreshCart(), {signal: this.controller.signal});
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refreshCart();
      }, {signal: this.controller.signal});
      this.refreshCart();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.sequence++;
    }
    async refreshCart() {
      const sequence = ++this.sequence;
      try {
        const response = await fetch(this.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (sequence === this.sequence && this.isConnected) this.renderCart(cart);
      } catch (error) {
        if (sequence === this.sequence && error.name !== 'AbortError') this.hidden = true;
      }
    }
    renderCart(cart) {
      this.lastCart = cart;
      const label = this.closest('.stellar-buyer-benefits')?.querySelector('stellar-product-shipping-label');
      const freeLabel = label?.dataset.free === 'true';
      const threshold = Number(this.dataset.threshold);
      const remaining = threshold - Number(cart.total_price);
      const discount = Number(cart.total_discount) || 0;
      const original = Number(cart.original_total_price) || 0;
      this.hidden = freeLabel || !cart.item_count || !(threshold > 0) || !(remaining > 0) || discount > original * 0.2 || (cart.currency && cart.currency !== this.dataset.currency);
      if (this.hidden) return;
      const amount = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {
        style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: remaining % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(remaining / 100);
      const message = this.dataset.template.split('[amount]').join(amount);
      const boundary = message.search(/ to qualify for /i);
      this.replaceChildren();
      if (boundary < 0) { this.textContent = message; return; }
      this.append(document.createTextNode(message.slice(0, boundary + 1)));
      const qualification = document.createElement('span');
      qualification.className = 'stellar-shipping-progress__qualification';
      qualification.textContent = message.slice(boundary + 1);
      this.append(qualification);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
